import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  useTheme,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  IconButton,
  styled,
  Box,
  Stack,
} from "@mui/material";
import {
  ArrowForward,
  LocationOn,
  Work,
  LinkedIn,
  Twitter,
  Language,
} from "@mui/icons-material";
import AttendeeModal from "./AttendeeModal";
import { useTranslation } from "react-i18next";

const CompactCard = styled(Card)(({ theme }) => ({
  position: "relative",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  borderRadius: "12px",
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[6],
    "& .hover-content": {
      opacity: 1,
      visibility: "visible",
    },
  },
}));

const HoverContent = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.primary.light} 90%)`,
  opacity: 0,
  visibility: "hidden",
  transition: "all 0.3s ease",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const AttendeeCard = ({ refresh, attendee, attendees, role, user }) => {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();
  // console.log("atendeecard", user);

  return (
    <>
      <CompactCard elevation={2} onClick={() => setOpenModal(true)}>
        <HoverContent className="hover-content">
          <Stack direction="row" spacing={1}>
            {attendee.linkedin && (
              <IconButton
                href={attendee.linkedin}
                target="_blank"
                sx={{ color: "white" }}
                onClick={(e) => e.stopPropagation()}
              >
                <LinkedIn fontSize="small" />
              </IconButton>
            )}
            {attendee.twitter && (
              <IconButton
                href={attendee.twitter}
                target="_blank"
                sx={{ color: "white" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Twitter fontSize="small" />
              </IconButton>
            )}
            {attendee.website && (
              <IconButton
                href={attendee.website}
                target="_blank"
                sx={{ color: "white" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Language fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </HoverContent>

        <CardContent
          sx={{
            p: 2,
            position: "relative",
            zIndex: 1,
            background: theme.palette.background.paper,
            borderRadius: "12px",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar
              src={attendee.profile_pic}
              variant="rounded"
              sx={{
                width: 64,
                height: 64,
                border: `2px solid ${theme.palette.primary.main}`,
                bgcolor: theme.palette.primary.light,
              }}
            >
              {!attendee.profile_pic &&
                `${attendee.name[0]}${attendee.name.split(" ")[1]?.[0] || ""}`}
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                noWrap
                sx={{ lineHeight: 1.2, mb: 0.5 }}
              >
                {attendee.name}
              </Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <Chip
                  label={attendee.role}
                  size="small"
                  color="primary"
                  sx={{ borderRadius: "4px", height: 24 }}
                />
                {attendee.yoe && (
                  <Chip
                    label={`${attendee.yoe}yrs`}
                    size="small"
                    variant="outlined"
                    sx={{ borderRadius: "4px", height: 24 }}
                  />
                )}
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <Work
                  fontSize="small"
                  sx={{ color: "text.secondary", fontSize: 16 }}
                />
                <Typography
                  variant="body2"
                  noWrap
                  sx={{ color: "text.secondary" }}
                >
                  {attendee.designation} @ {attendee.company}
                </Typography>
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 0.5 }}
              >
                <LocationOn
                  fontSize="small"
                  sx={{ color: "text.secondary", fontSize: 16 }}
                />
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {attendee.country === "OM" ? "Oman" : attendee.country}
                  {attendee.city && `, ${attendee.city}`}
                </Typography>
              </Stack>
            </Box>
          </Stack>

          {attendee.industry && (
            <Box sx={{ mt: 1.5, textAlign: "center" }}>
              <Chip
                label={attendee.industry}
                size="small"
                color="secondary"
                sx={{ borderRadius: "4px", height: 24 }}
              />
            </Box>
          )}
        </CardContent>
      </CompactCard>

      <AttendeeModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        attendee={attendee}
        attendees={attendees}
        refresh={refresh}
        role={role}
        user={user}
      />
    </>
  );
};

// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import {
//   useTheme,
//   Card,
//   CardContent,
//   Typography,
//   Avatar,
//   Chip,
//   IconButton,
//   Divider,
//   styled,
//   Box,
//   Button,
// } from "@mui/material";
// import { ArrowForward, LocationOn, Work } from "@mui/icons-material";
// import AttendeeModal from "./AttendeeModal";
// import { useTranslation } from "react-i18next";


// const StyledCard = styled(Card)(({ theme }) => ({
//   width: "100%",
//   height: "100%",
//   position: "relative",
//   overflow: "visible",
//   transition: "transform 0.3s ease, box-shadow 0.3s ease",
//   cursor: "pointer",
//   "&:hover": {
//     transform: "translateY(-8px)",
//     boxShadow: theme.shadows[6],
//     "& .hover-gradient": {
//       opacity: 1,
//     },
//   },
// }));

// const HoverEffect = styled("div")(({ theme }) => ({
//   position: "absolute",
//   inset: 0,
//   // background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.dark} 100%)`,
//   opacity: 0,
//   transition: "opacity 0.3s ease",
//   borderRadius: theme.shape.borderRadius,
//   zIndex: 0,
// }));

// const AttendeeCard = ({ refresh, attendee, attendees, role }) => {
//   const theme = useTheme();
//   const [openModal, setOpenModal] = useState(false);
//   const { t } = useTranslation();

//   return (
//     <>
//       <StyledCard elevation={3}>
//         <HoverEffect className="hover-gradient" />
//         <CardContent
//           sx={{
//             zIndex: 1,
//             p: 3,
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             borderRadius: theme.shape.borderRadius,
//             boxShadow: theme.shadows[10],
//             border: `1px solid ${theme.palette.divider}`,
//             background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.action.hover} 100%)`,
//             position: "relative",
//             overflow: "visible",
//             mb: 4,
//             backgroundImage:
//               theme.palette.mode === "light"
//                 ? `url(${BackgroundShape})`
//                 : "none",
//             backgroundBlendMode: "multiply",
//             backgroundRepeat: "no-repeat",
//             backgroundSize: "cover",
//             color: "#fff",
//           }}
//         >
//           {/* Profile Section */}
//           <Avatar
//             src={attendee.profile_pic}
//             alt={attendee.name}
//             sx={{
//               width: 100,
//               height: 100,
//               mx: "auto",
//               mb: 2,
//               border: `3px solid ${theme.palette.primary.main}`,
//               boxShadow: 3,
//               bgcolor: attendee.profile_pic
//                 ? "transparent"
//                 : theme.palette.primary.main,
//               color: "white",
//               fontSize: 24,
//               fontWeight: "bold",
//             }}
//           >
//             {!attendee.profile_pic &&
//               `${attendee.name.split(" ")[0][0]}${
//                 attendee.name.split(" ")[1]
//                   ? attendee.name.split(" ")[1][0]
//                   : ""
//               }`}
//           </Avatar>

//           {/* Name & Role */}
//           <Typography
//             variant="h6"
//             textTransform={"uppercase"}
//             fontWeight={700}
//             textAlign="center"
//           >
//             {attendee.name}
//           </Typography>
//           <Chip
//             label={attendee.role.toUpperCase()}
//             size="small"
//             color="primary"
//             sx={{
//               mt: 1,
//               mb: 2,
//               fontWeight: 600,
//               letterSpacing: 0.5,
//             }}
//           />

//           <Divider sx={{ width: "40%", my: 2 }} />

//           {/* Details */}
//           <Box
//             sx={{
//               width: "100%",
//               textAlign: "center",
//               mb: 2,
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 mb: 1,
//               }}
//             >
//               <Work fontSize="small" sx={{ mr: 1, color: "text.secondary" }} />
//               <Typography
//                 variant="body2"
//                 textTransform={"capitalize"}
//                 color="text.secondary"
//               >
//                 {attendee.designation}
//               </Typography>
//             </Box>
//             <Typography
//               variant="body2"
//               textTransform={"capitalize"}
//               color="text.secondary"
//               sx={{ mb: 1 }}
//             >
//               {attendee.company}
//             </Typography>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <LocationOn
//                 fontSize="small"
//                 sx={{ mr: 1, color: "text.secondary" }}
//               />
//               <Typography
//                 variant="body2"
//                 textTransform={"uppercase"}
//                 color="text.secondary"
//               >
//                 {attendee.country === "OM" ? "Oman" : attendee.country}
//               </Typography>
//             </Box>
//           </Box>

//           {/* View Button */}
//           <Button
//             sx={{
//               mt: "auto",
//               bgcolor: "primary.main",
//               color: "primary.contrastText",
//               "&:hover": {
//                 bgcolor: "primary.dark",
//               },
//             }}
//             onClick={() => setOpenModal(true)}
//           >
//             {t("Profile")} <ArrowForward />
//           </Button>
//         </CardContent>
//       </StyledCard>

//       <AttendeeModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         attendee={attendee}
//         attendees={attendees}
//         refresh={refresh}
//         role={role}
//       />
//     </>
//   );
// };

AttendeeCard.propTypes = {
  attendee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    bio: PropTypes.string,
    profile_pic: PropTypes.string,
    linkedin: PropTypes.string,
    twitter: PropTypes.string,
    website: PropTypes.string,
    yoe: PropTypes.number,
    industry: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  attendees: PropTypes.array.isRequired,
  refresh: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default AttendeeCard;
